export class CustomerSearch {
    buyerId = 0;
    customerName = '';
    address = '';
    city = '';
    country = '';
    state = '';
    zipCode = '';
}
